import React, { useEffect, useState } from 'react';
import { Box, Typography, IconButton, ListItem, Collapse } from '@material-ui/core';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import { createStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { darkTheme, lightTheme } from '../layout/themes';
import { makeStyles } from '@material-ui/core';
import { Link } from "react-router-dom";
import colors from '../CustomizedUIs/Colors';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import { useDataProvider, Loading, useTranslate } from 'react-admin';
import CustomTextField from '../users/CustomTextField'
import CustomSwitch from '../CustomizedUIs/GreenSwitch'
import { Alert } from '@material-ui/lab';
import { isBlocking } from './actions';
import GoBackButton from '../CustomizedUIs/GoBackButton';

const useStyles = makeStyles((theme) =>
    createStyles({
        expandText: {
            fontFamily: 'UniviaPro-Bold',
            fontSize: '9px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.22,
            letterSpacing: '0.36px',
            color: '#4f5064',
            padding: '5px 8px 5px 8px'
        }, expandGroup: {
            width: 150,
            height: 30,
            float: 'right',
            backgroundColor: theme.palette.common.white,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around'
        },
        TextBack: {
            fontFamily: 'UniviaPro-Medium',
            fontSize: '15px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.2,
            letterSpacing: 'normal',
            color: '#237fc2',
        },
        TitleName: {
            fontFamily: 'UniviaPro-Medium',
            fontSize: '18px',
            fontWeight: 500,
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.2,
            letterSpacing: 'normal',
            color: '#4f5064',
        },
        BoxExpand: {
            width: '134px',
            height: '30px',
            borderRadius: '4px',
            backgroundColor: '#ffffff',
        }, underline: {
            '&::before': {
                borderBottom: '1px solid black'
            },
            '&:hover:not($disabled):before': {
                borderBottom: '1px solid black'
            }
        },
        underlineNotValue: {
            '&::before': {
                borderBottom: '1px solid' + colors.lightBlue['200']
            },
            '&:hover:not($disabled):before': {
                borderBottom: '1px solid' + colors.lightBlue['200']
            }
        },
        focuses: {
            backgroundColor: 'white !important'
        },
        boxBoder: {
            borderBottom: '1px solid',
            borderRight: '1px solid',
            borderBottomColor: '#f3f7fa',
            borderRightColor: '#f3f7fa',
        },
        display: {
            display: 'none',
        }, input: {
            backgroundColor: 'white',
            borderRadius: '2px',
            "&:hover": {
                backgroundColor: 'white'
            }, fontFamily: 'UniviaPro',
            fontSize: '13px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.85,
            letterSpacing: '0.13px',
            color: '#4f5064',
        }, TexTSelect: {
            fontFamily: 'UniviaPro',
            fontSize: '13px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.85,
            letterSpacing: '0.13px',
            color: '#4f5064',
        }

    }),
);

const IconTitle = ({ TitleBack, TitleName, expandAll, onExpandAllChanged, handleInherit, textValue, setTextValue, errorMessage }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const dataProvider = useDataProvider();
    const [role, setRole] = useState();
    const [dataRole, setDataRole] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const classes = useStyles();
    const translate = useTranslate();
    const [openRole, setOpenRole] = useState(false);
    const dispatch = useDispatch();
    const [validate, setValidate] = React.useState({
        role: {
            isError: true,
            message: ''
        },

    });
    const handleClosePoper = () => {
        setOpenPopper(false);
    };
    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };
    const theme = useSelector((state) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );
    useEffect(() => {

        dataProvider('GET_LIST', "rolesList", {
            filter: {},
            pagination: {},
            sort: {},

        })
            .then(({ data }) => {
                setDataRole(data);
                setRole(data)
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
    }, []);
    if (!dataRole || !role) return null
    if (loading) return <Loading />;
    if (error) return null;

    const textOnChange = prop => (e) => {
        dispatch(isBlocking(true))
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validateFc(prop, e.target.value)
    }

    const validateFc = (prop, value) => {
        if (prop === 'role') {
            if (value.length === 0)
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                            isError: false, message: ''
                        }
                })
            else {
                setValidate({
                    ...validate, [prop]: value.length > 50 ? {
                        isError: true, message: translate(`pos.user.error.rolenamecharacter`)
                    } : {
                            isError: false, message: ''
                        }
                })
            }
        }
        else
            setValidate({
                ...validate, [prop]: value.length === 0 ? {
                    isError: true, message: 'required'
                } : {
                        isError: false, message: ''
                    }
            })
    }
    const handleClickOpenRole = () => {
        setOpenRole(!openRole)
    }
    const onChangeRole = (value) => {
        dispatch(isBlocking(true))
        setRole(value)
        handleInherit(value.id)
        setOpenRole(false)
    }
    return (
        <Box my={2} width="100%" >
            <Box my={5} width={300} display='flex' component={Link} to={{ pathname: "/roles" }} style={{ textDecoration: 'none' }}>
                <Box display='flex' mr={2}>
                    <GoBackButton style={{ margin: 'auto', padding: 0 }} />

                </Box>
                <Typography className={classes.TextBack} style={{ margin: 'auto 0' }}>{TitleBack}</Typography>
            </Box>
            <Box display="flex" width='100%' justifyContent='center'>
                <Box display="flex" width='700px'>

                    <Typography className={classes.TitleName} style={{ margin: 'auto 0' }}>{TitleName}</Typography>

                </Box>
            </Box>
            <Box display="flex" width='100%' justifyContent='center'>
                <Box my={2} style={{ width: '700px' }} >
                    <Box mt={3}>
                        <Collapse in={errorMessage}>
                            <Alert severity={"error"}>{errorMessage}</Alert>
                        </Collapse>
                    </Box>
                    <Box mt={3} ml={12}>
                        <CustomTextField
                            required
                            onBlur={() => {
                                validateFc('role', textValue.role)
                            }}
                            id="filled-basic"
                            label={translate(`resources.role.roleName`)}
                            value={textValue.role}
                            error={validate.role.message != "" && validate.role.isError}
                            helperText={validate.role.message}
                            onChange={textOnChange('role')}
                            style={{ width: 500 }}
                            endDom={
                                <CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`resources.role.rolename`)}
                                    content={translate(`resources.role.ConstentRole`)}
                                    icon={<b>?</b>}
                                />}
                        />
                    </Box>
                    <Box ml={12} pt={1} pb={0} mt={1} style={{ width: 500 }} >
                        <SelectBox

                            label={translate(`pos.user.role`)}
                            value={<Typography className={classes.TexTSelect} >{role.name}</Typography>}
                            open={openRole}
                            handleClick={handleClickOpenRole}
                        >
                            {
                                dataRole.map((role, index) => (
                                    <Box hidden={role.name === "Sysadmin" ? true : false} key={index} className={classes.boxBoder}>
                                        <ListItem style={{ padding: '8px' }} button onClick={() => onChangeRole(role)}>
                                            <Typography className={classes.TexTSelect} >{role.name}</Typography>
                                        </ListItem>
                                    </Box>
                                ))
                            }
                        </SelectBox>
                    </Box>
                </Box>
            </Box>
            <Box display="flex" width='100%' justifyContent='center'>
                <Box display='flex' width="700px"  >
                    <Box pl={2} alignItems='center' marginLeft='auto' display='flex' className={classes.BoxExpand}  >
                        <Typography className={classes.expandText} >{translate('resources.role.expandall')}</Typography>
                        <CustomSwitch color="primary" size="small" checked={expandAll} onChange={onExpandAllChanged} />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
export default IconTitle;